const { Box,TextField,InputAdornment, Typography  } = require("@mui/material");
const { GridFooterContainer, GridFooter } = require("@mui/x-data-grid");

const CustomFooter = (props) => {
	const overLimit = Number(props.distributedPoints) > 100;

	return (
		<GridFooterContainer>
			{props.showAllocation && <>
				<Box sx={{width:265, paddingX: '10px', display: 'flex', justifyContent: 'flex-end'}}>Total: </Box>
				<Box sx={{width:90}}>
					<TextField
						fullWidth
						size="small"
						value={props.distributedPoints ?? ''}
						InputLabelProps={{ shrink: true }}
						InputProps={{
							readOnly: true,
							endAdornment: (
								<InputAdornment position="end">
									<Typography
										component="span"
										sx={{
											color: overLimit ? 'error.main' : 'text.primary',
											fontWeight: overLimit ? 800 : 700,
											lineHeight: 1
										}}
									>
										%
									</Typography>
								</InputAdornment>
							),
							inputProps: {
								min: 0,
								max: 100,
								style: { textAlign: 'center', fontWeight: 700 }
							}
						}}
						sx={{
							'& .MuiInputBase-root': { height: 34, backgroundColor: '#eef7ff' },
							'& .MuiInputAdornment-root': { marginLeft: 0 },
							'& input': { paddingRight: 0, color: overLimit ? 'red' : 'inherit', fontWeight: overLimit ? 800 : 700 }
						}}
					/>
				</Box>
			</>}
			<Box flex={1}>
				<GridFooter sx={{ border: 'none' }} />
			</Box>
		</GridFooterContainer>
	);
}

export default CustomFooter
